import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService, OperatorService, UserService} from "../services";
import {Subject} from "rxjs";

@Component({
    templateUrl: './operator.component.html',
    styleUrls: ['./operator.component.scss']
})
export class OperatorComponent implements OnDestroy, OnInit {
    rows: any[];
    loadingIndicator: boolean;
    reorderable: boolean;

    // Private
    private _unsubscribeAll: Subject<any>;

    constructor(
        private operatorService: OperatorService,
        private alertService: AlertService
    ) {
        // Set the defaults
        this.loadingIndicator = true;
        this.reorderable = true;

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    ngOnInit() {
        this.operatorService.getAll().subscribe((res: any[])=>{
            this.rows = res;
            this.loadingIndicator = false;
        }, error => {
            this.alertService.error(error);
        })
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
